export const LABELS_LOAD = 'LABELS_LOAD';
export const LABELS_RELOAD = 'LABELS_RELOAD';
export const LABEL_CREATE = 'LABEL_CREATE';
export const LABEL_RECREATE = 'LABEL_RECREATE';
export const LABEL_UPDATE = 'LABEL_UPDATE';
export const LABEL_DELETE = 'LABEL_DELETE';
export const LABEL_SELECT = 'LABEL_SELECT';
export const LABELS_MARK_STALE = 'LABELS_MARK_STALE';

export const LABEL_ID_PREFIX = 'lbl_';
export const LABEL_NAME_MAX_LENGTH = 30;
